.kg{border-radius:0.375rem;}